import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconCoin } from "@tabler/icons-react";
import { CondicionesFacturacionDef } from "./CondicionesFacturacionDef";

export const CondicionesFacturacionHelpText = '* Aquí puede ver las condiciones de facturación.';
export const CondicionesFacturacionIcon = IconCoin;
export class CondicionesFacturacion extends Entity<CondicionesFacturacionDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new CondicionesFacturacionDef(), parentKeys);
        this.Form = import('./CondicionesFacturacionForm').then((module) => module.CondicionesFacturacionForm);
        this.Icon = CondicionesFacturacionIcon;
        this.HelpText = CondicionesFacturacionHelpText;
        this.Title = "Condiciones de Facturación";
    }
}